const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The team was punctual, friendly, and thoroughly cleaned my air ducts. I noticed better air quality right away.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Jessica T.",
    "review": "Master Air Duct exceeded my expectations. They cleaned all the vents, and I can already feel the difference in airflow. Highly recommend!",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The techs were knowledgeable, explained the process, and left everything spotless.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. I appreciate how the team paid attention to every detail. My home feels fresher.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough air duct cleaning. I'm breathing easier, and it’s all thanks to Master Air Duct.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job with my air ducts. The team was respectful of my home and got the job done quickly.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the quality of service. The technicians were polite and took care of everything efficiently.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Kevin H.",
    "review": "Master Air Duct provided excellent service, and I noticed less dust in the house immediately after cleaning.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Eric W.",
    "review": "The technicians were professional and completed the cleaning quickly. My HVAC system is running smoother now.",
    "service": "Air Duct Cleaning"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job cleaning our dryer vent. It was long overdue, and now the dryer works much better!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Tom C.",
    "review": "Master Air Duct saved us from a potential fire hazard by thoroughly cleaning the dryer vent. Very grateful!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their dryer vent cleaning service. They arrived on time and finished the job without any mess.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. My dryer runs more efficiently, thanks to their excellent service.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Maria S.",
    "review": "Master Air Duct did an amazing job cleaning the dryer vent. I never realized how much lint could accumulate over time!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll be scheduling regular dryer vent cleanings with them.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The techs were knowledgeable and explained the importance of regular dryer vent cleaning.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Ben A.",
    "review": "I had a significant buildup in my dryer vent, but Master Air Duct handled it well. Great job!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and did a thorough job. I appreciate their attention to safety.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the dryer vent cleaning. The team was professional, and I can already tell the difference in drying time.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Alex P.",
    "review": "The team found and fixed a leak in my ductwork that I didn't even know existed. Great service!",
    "service": "Duct Repair"
  },
  {
    "customer": "Brandon L.",
    "review": "Had a repair done on my air ducts, and they did an excellent job. The airflow has improved significantly.",
    "service": "Duct Repair"
  },
  {
    "customer": "Nina J.",
    "review": "They quickly identified and fixed the issue with my ducts. I’m very happy with the results.",
    "service": "Duct Repair"
  },
  {
    "customer": "Trevor M.",
    "review": "Master Air Duct repaired a leak in our duct system. It’s working much better now, and we’re very satisfied.",
    "service": "Duct Repair"
  },
  {
    "customer": "Katie W.",
    "review": "The team was able to repair some damaged ducts and improve our home's air quality. Highly recommend.",
    "service": "Duct Repair"
  },
  {
    "customer": "Chris B.",
    "review": "The technicians did a thorough inspection and fixed some issues we weren't aware of. Great job!",
    "service": "Duct Repair"
  },
  {
    "customer": "Megan R.",
    "review": "Very satisfied with their service. They identified and repaired some leaks in my duct system.",
    "service": "Duct Repair"
  },
  {
    "customer": "Danny H.",
    "review": "The repair work on my duct system was quick, and the results were excellent. I appreciate their professionalism.",
    "service": "Duct Repair"
  },
  {
    "customer": "Lauren T.",
    "review": "Master Air Duct did a wonderful job repairing our ducts. The air flow is now consistent in all rooms.",
    "service": "Duct Repair"
  },
  {
    "customer": "Rick A.",
    "review": "They were able to repair the issues in our ducts promptly. I’m very pleased with their service.",
    "service": "Duct Repair"
  },
  {
    "customer": "Ashley E.",
    "review": "The techs were professional and repaired the ducts efficiently. Our home feels more comfortable now.",
    "service": "Duct Repair"
  },
  {
    "customer": "Monica G.",
    "review": "The team was able to fix a leak in my ductwork that was affecting the air quality. Great job!",
    "service": "Duct Repair"
  },
  {
    "customer": "Hank F.",
    "review": "I was impressed by their thorough inspection and repair work. They really know what they're doing.",
    "service": "Duct Repair"
  },
  {
    "customer": "Jasmine K.",
    "review": "Master Air Duct repaired our ducts and also cleaned them. The service was fantastic, and the results are noticeable.",
    "service": "Duct Repair"
  }
]
  
export default LocationReviewsData;
